import { render } from "./DimensionMetadata.vue?vue&type=template&id=ac9e9f68"
import script from "./DimensionMetadata.vue?vue&type=script&lang=js"
export * from "./DimensionMetadata.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/cube-viewer/cube-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__